import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { COLORS, SHADOWS } from '../constants/styles';

const SwitchWrapper = styled.button`
    align-items: center;
    background-color: ${(props: { on?: boolean }) => (props.on ? COLORS.rakutenRed : '#ebe9e9')};
    color: ${(props: { on?: boolean }) => (props.on ? COLORS.white : COLORS.grey7)};
    border: none;
    border-radius: 100px;
    cursor: ${(props: { on?: boolean; disabled?: boolean }) =>
        props.disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    font-size: 0.875rem;
    opacity: ${(props: { on?: boolean; disabled?: boolean }) => (props.disabled ? '0.4' : '1')};
    padding: 10px 30px;
    position: relative;
`;

const SwitchText = styled.span`
    margin-left: ${(props: { on?: boolean }) => (props.on ? '' : '5px')};
    margin-right: ${(props: { on?: boolean }) => (props.on ? '5px' : '')};
    font-weight: ${(props: { on?: boolean }) => (props.on ? '500' : 'normal')};
`;

const SwitchDot = styled.div`
    background: ${COLORS.white};
    border-radius: 50%;
    bottom: 0;
    box-shadow: ${SHADOWS.level3};
    height: 25px;
    margin: auto;
    position: absolute;
    top: 0;
    transition: right 0.3s;
    right: ${(props: { on?: boolean }) => (props.on ? '5px' : 'calc(100% - 30px)')};
    width: 25px;
`;

interface ISwitchProps {
    value: boolean;
    disabled?: boolean;
    onSwitch: (value: boolean) => any;
    children?: ReactNode;
}

interface ISwitchState {
    on: boolean;
}

class Switch extends React.Component<ISwitchProps, ISwitchState> {
    constructor(props: ISwitchProps) {
        super(props);

        const { value } = this.props;

        this.state = {
            on: Boolean(value),
        };
    }

    public render() {
        const { children, value, disabled, onSwitch } = this.props;
        const { on } = this.state;
        const onClick = (() => {
            if (!disabled) {
                const newOn = !on;
                this.setState({ on: newOn });
                onSwitch(newOn);
            }
        }).bind(this);

        return (
            <SwitchWrapper
                disabled={disabled}
                role="switch"
                aria-checked={on}
                aria-disabled={disabled}
                on={on}
                onClick={onClick}
                tabIndex={0}
            >
                <SwitchDot on={on} />
                <SwitchText on={on}>{children}</SwitchText>
            </SwitchWrapper>
        );
    }
}

export default Switch;
